/**
 * @generated SignedSource<<8699e77c82395cfa12bab6acf94ac458>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedLayout_viewer$data = {
  readonly homepage: {
    readonly modules: ReadonlyArray<{
      readonly type?: string | null;
      readonly visible?: boolean | null;
      readonly " $fragmentSpreads": FragmentRefs<"HpSharedEditorialModule_componentModule" | "HpSharedFeaturedBannerModule_componentModule" | "HpSharedTopHeroBannerModule_componentModule">;
    } | null> | null;
    readonly personalizationCollections?: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"HpSharedNewArrivalsCarouselTabs_personalizationCollections">;
    } | null> | null;
  } | null;
  readonly user?: {
    readonly hasLoggedInWithApp: boolean | null;
    readonly " $fragmentSpreads": FragmentRefs<"HpSharedAppBanner_user" | "HpSharedFeaturedModule_user" | "HpSharedItemsGrid_user" | "HpSharedNewArrivalsTabContent_user" | "HpSharedTopHeroBannerModule_user" | "HpSharedUserRecommendations_user">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModule_viewer" | "HpSharedNewArrivalsTabContent_viewer" | "HpSharedTopHeroBannerModule_viewer">;
  readonly " $fragmentType": "HpSharedLayout_viewer";
};
export type HpSharedLayout_viewer$key = {
  readonly " $data"?: HpSharedLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedLayout_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v1 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "recommendationType",
    "variableName": "recommendationType"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "abTestList"
    },
    {
      "kind": "RootArgument",
      "name": "fetchInitialHomepage"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "homepageId"
    },
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "isRemoveTopHeroBannerTestVariant"
    },
    {
      "defaultValue": "PERSONALIZED",
      "kind": "LocalArgument",
      "name": "recommendationType"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedLayout_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "abTestList",
          "variableName": "abTestList"
        },
        {
          "kind": "Variable",
          "name": "rootId",
          "variableName": "homepageId"
        }
      ],
      "concreteType": "Homepage",
      "kind": "LinkedField",
      "name": "homepage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "modules",
          "plural": true,
          "selections": [
            {
              "condition": "isRemoveTopHeroBannerTestVariant",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*:: as any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "HpSharedTopHeroBannerModule_componentModule"
                    }
                  ],
                  "type": "TopHeroBannerModule",
                  "abstractKey": null
                }
              ]
            },
            {
              "condition": "fetchInitialHomepage",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*:: as any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "HpSharedEditorialModule_componentModule"
                    }
                  ],
                  "type": "EditorialModule",
                  "abstractKey": null
                }
              ]
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*:: as any*/)
              ],
              "type": "LocationsModule",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "visible",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "HpSharedFeaturedBannerModule_componentModule"
                }
              ],
              "type": "BottomBannerModule",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "condition": "hasUserId",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "numItems",
                  "value": 10
                },
                {
                  "kind": "Literal",
                  "name": "pageSize",
                  "value": 3
                },
                (v1/*:: as any*/)
              ],
              "concreteType": "PersonalizationCollectionType",
              "kind": "LinkedField",
              "name": "personalizationCollections",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "HpSharedNewArrivalsCarouselTabs_personalizationCollections"
                }
              ],
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedNewArrivalsTabContent_viewer"
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedFeaturedModule_viewer"
        }
      ]
    },
    {
      "condition": "isRemoveTopHeroBannerTestVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedTopHeroBannerModule_viewer"
        }
      ]
    },
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            (v1/*:: as any*/)
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": "hasLoggedInWithApp",
              "args": [
                {
                  "kind": "Literal",
                  "name": "deviceType",
                  "value": "IOS_APP"
                }
              ],
              "kind": "ScalarField",
              "name": "hasLoggedInWithDeviceType",
              "storageKey": "hasLoggedInWithDeviceType(deviceType:\"IOS_APP\")"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "HpSharedNewArrivalsTabContent_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "HpSharedFeaturedModule_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "HpSharedAppBanner_user"
            },
            {
              "condition": "isRemoveTopHeroBannerTestVariant",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "HpSharedTopHeroBannerModule_user"
                }
              ]
            },
            {
              "args": (v2/*:: as any*/),
              "kind": "FragmentSpread",
              "name": "HpSharedUserRecommendations_user"
            },
            {
              "args": (v2/*:: as any*/),
              "kind": "FragmentSpread",
              "name": "HpSharedItemsGrid_user"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "80cb6207383d296bb6228562bc21e430";

export default node;
